import { deleteWorkItem } from "../../../services/workItem";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_ITEMS } from "../queries/useQueryWorkItems";

export const useMutationDeleteWorkItem = () =>
  useWSMutation<
    void,
    WSServiceError,
    {
      workItemId: string;
    }
  >(data => deleteWorkItem(data.workItemId), {
    dependencies: [QUERY_WORK_ITEMS]
  });
